var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 36.375C28.8198 36.375 36.375 28.8198 36.375 19.5C36.375 10.1802 28.8198 2.625 19.5 2.625C10.1802 2.625 2.625 10.1802 2.625 19.5C2.625 28.8198 10.1802 36.375 19.5 36.375Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 13.875C24.4103 13.2859 23.9168 12.8001 23.3223 12.4698C22.7278 12.1396 22.0547 11.9772 21.375 12H17.625C16.6304 12 15.6766 12.3951 14.9734 13.0984C14.2701 13.8017 13.875 14.7555 13.875 15.75C13.875 16.7446 14.2701 17.6984 14.9734 18.4017C15.6766 19.105 16.6304 19.5 17.625 19.5H21.375C22.3696 19.5 23.3234 19.8951 24.0266 20.5984C24.7299 21.3017 25.125 22.2555 25.125 23.25C25.125 24.2446 24.7299 25.1984 24.0266 25.9017C23.3234 26.605 22.3696 27.0001 21.375 27.0001H17.625C16.9453 27.0229 16.2722 26.8605 15.6777 26.5303C15.0832 26.2 14.5897 25.7142 14.25 25.125",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 27V30.75M19.5 8.25V12V8.25Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinBalance);
export default __webpack_public_path__ + "static/media/coin-balance.57fca69866923c0b0b393d55d05763d9.svg";
export { ForwardRef as ReactComponent };